import { Dispatch, createContext } from 'react';
import { RootStateAction } from './actions/rootStateActions';
import { defaultFeatureFlagsState } from './models/featureFlags';
import { RootState } from './models/rootState';
import { AppTheme, AppThemeMode, FORCED_LIGHT_THEME_MODE, FORCED_DARK_THEME_MODE, FROM_DEVICE_THEME_MODE, LIGHT_THEME, DARK_THEME, PREFERRED_THEME_MODE_LOCAL_STORAGE_KEY } from './models/theme';
import { GptTypes } from '../EnterpriseGPTApi/EnterpriseGPTApiV1Client';

// Fonction pour initialiser le thème en fonction du themeMode
const getInitialTheme = (themeMode: AppThemeMode): AppTheme => {
    switch (themeMode) {
        case FORCED_DARK_THEME_MODE:
            return DARK_THEME;
        case FORCED_LIGHT_THEME_MODE:
            return LIGHT_THEME;
        case FROM_DEVICE_THEME_MODE:
            return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? DARK_THEME : LIGHT_THEME;
        default:
            return LIGHT_THEME;
    }
};

// Récupération du themeMode depuis le localStorage
const initialThemeMode = (localStorage.getItem(PREFERRED_THEME_MODE_LOCAL_STORAGE_KEY) as AppThemeMode) || FORCED_LIGHT_THEME_MODE;

export const initialRootState: RootState = {
    chats: [
        {
            id: 'DRAFT',
            userName: '',
            startedOn: new Date(),
            currentQuery: '',
            prompts: [],
            title: '',
            llm: '',
            lastUpdateOn: undefined,
            draft: true,
            gpt: {
                id: '00000000-0000-0000-0000-000000000000',
                type: GptTypes.SyGpt
            }
        },
    ],
    conversationsCursor: undefined,
    quota: {
        userQuota: undefined,
        userQuotaPercentage: undefined,
    },
   
    themeMode: initialThemeMode,
    theme: getInitialTheme(initialThemeMode),
    features: {
        ...defaultFeatureFlagsState,
    },    
    userPreferences: {
        featureHighlights: {},
        speechClickSend: false,
        showLanguageSelectionInPrompt: true,

    },
    gptConfigurations: [],
    survey: undefined
    ,
    conversationsLoading: true,
    appLoading: true
};
const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
export type StoreContextType = {
    state: RootState;
    dispatch: Dispatch<RootStateAction>;
};

export const Store = createContext<StoreContextType>({
    state: initialRootState,
    dispatch: () => null,
});
